import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=202c768a"
import script from "./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports